import { IconDefinition, faPencil, faCheckCircle, faCircleXmark } from '@fortawesome/pro-light-svg-icons'
import { SellTicketStatusKeys } from '@teinor/erp/types/company/order/sell/sellTicket'
import { DisplayStatus } from '../../../../../../baseComponents/Displays/DisplayStatus'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface RenderSellTicketStatusProps {
    value: string
}
interface StatusSellTicketTy {
    colorText: string
    icon: IconDefinition
    text: string
}
export const RenderSellTicketStatus: React.FC<RenderSellTicketStatusProps> = ({ value }) => {
    const parsedValue = parseInt(value)
    const { t } = useTwinTranslation()
    const statusSellTicket: Record<SellTicketStatusKeys, StatusSellTicketTy> = {
        0: { text: t('draft', 'Borrador'), colorText: 'text-gray-97', icon: faPencil },
        1: { text: t('saved', 'Guardado'), colorText: 'text-purple-86', icon: faPencil },
        2: { text: t('reservedM', 'Reservado'), colorText: 'text-green-43', icon: faCheckCircle },
        3: { text: t('charged', 'Cobrado'), colorText: 'text-green-43', icon: faCheckCircle },
        4: { text: t('partialRefundedShort', 'Dev. parcial'), colorText: 'text-yellow-B9', icon: faCircleXmark },
        5: { text: t('refunded', 'Devuelto'), colorText: 'text-red-BA', icon: faCircleXmark },
        6: { text: t('canceled', 'Cancelado'), colorText: 'text-red-BA', icon: faCircleXmark },
    }
    return <DisplayStatus icon={statusSellTicket[parsedValue as SellTicketStatusKeys].icon} colorText={statusSellTicket[parsedValue as SellTicketStatusKeys].colorText} text={statusSellTicket[parsedValue as SellTicketStatusKeys].text} />
}